import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { ActionCard } from "components/Card/ActionCard";
import { Text } from "components/text";
import { useOrganisation } from "~/contexts/OrganisationProvider";

export const OrganisationOnixPage = () => {
  const { t } = useTranslation("settings");
  const navigate = useNavigate();
  const { id: organisationId } = useOrganisation();

  return (
    <div className="space-y-6">
      <section>
        <Text as="h2" variant="pageHeading" className="mb-2">
          {t("organisation.onix.title")}
        </Text>
        <Text variant="subtle" className="pb-4">
          {t("organisation.onix.description")}
        </Text>

        <div className="space-y-4">
          <ActionCard
            title={t("organisation.onix.manual.title")}
            iconName="upload"
            onClick={() =>
              navigate({
                to: "/settings/organisations/$organisationId/onix-upload/manual",
                params: { organisationId },
              })
            }
          >
            <ActionCard.Action
              iconName="chevron-right"
              label={t("organisation.onix.manual.navigate")}
            />
          </ActionCard>
          <ActionCard
            title={t("organisation.onix.ftp.title")}
            iconName="server-cog"
            onClick={() =>
              navigate({
                to: "/settings/organisations/$organisationId/onix-upload/ftp",
                params: { organisationId },
              })
            }
          >
            <ActionCard.Action
              iconName="chevron-right"
              label={t("organisation.onix.ftp.navigate")}
            />
          </ActionCard>
        </div>
      </section>
    </div>
  );
};
